export class SettingsResponse {
    public code?: number;
    public response?: SettingResponse;
}

export class SettingResponse {
    public contact_number?: string;
    public key_map?: string;
    public chat_url?: string;
}